const disableCamionAction = {
	id: 'disableCamionAction',
	selectionType: 'single',
	label: 'camion.disablecamion',
	functionality: 'DISABLE_CAMION',
	checkAvailability: function (camion) {
		if (camion[0] && camion[0].indbaja === '0') {
			return true;
		} else {
			return false;
		}
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = {};
		// Comprobar PK (En este caso es compuesta)
		for (var index in model.columns) {
			const column = model.columns[index];
			if (column.isPk) {
				objectPk[column.name] = registries[0][column.name];
			}
		}
		row.headerPk = objectPk;
		row.isAction = true;
		row.fecbaja = this.$dateTimeUtils.getLocalDateNow();
		this.$puiEvents.$emit('pui-modalDialogForm-disable-' + model.name + '-show', row);
	}
};

function runEnableCamionPatch(ctx, action, model, idcamion) {
	var urlController = model.url.enable + '?idcamion=' + idcamion;
	var title = ctx.$puiI18n.t('puiaction.notifyTitle') + ' > ' + ctx.$puiI18n.t(action.label);

	ctx.$puiRequests.patchRequest(
		urlController,
		{},
		() => {
			ctx.$puiEvents.$emit(`onPui-action-running-showFormLoading-${model.name}`);
			ctx.$puiEvents.$emit('onPui-action-running-ended-' + model.name);

			var message = ctx.$puiI18n.t('puiaction.notifySuccess');
			ctx.$puiNotify.success(message, title);
		},
		() => {
			ctx.$puiEvents.$emit('onPui-action-running-ended-' + model.name);
			var message = ctx.$puiI18n.t('puiaction.notifyError');
			ctx.$puiNotify.error(message, title);
		}
	);
}

const enableCamionAction = {
	id: 'enableCamionAction',
	selectionType: 'single',
	label: 'camion.enablecamion',
	functionality: 'ENABLE_CAMION',
	checkAvailability: function (camion) {
		return camion[0] && camion[0].indbaja === '1';
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		this.$puiEvents.$emit('pui-modalDialog-confirm-' + model.name + '-show', row);
		this.$puiEvents.$on('pui-action-runAction-' + model.name, () => {
			this.$puiEvents.$off('pui-action-runAction-' + model.name);
			runEnableCamionPatch(this, action, model, row.idcamion);
		});
	}
};

export default {
	gridactions: [enableCamionAction, disableCamionAction],
	formactions: [enableCamionAction, disableCamionAction]
};
